import RequestContent from "../component/content/RequestContent";

const Request = () => {
    return (
        <RequestContent />
    )
};

export default Request;